
function useImagePath(){
    const home =process.env.PUBLIC_URL; // remember it need be the same of package.json
    let imageUrl = `${home}/img`;
    //console.debug(imageUrl); 
    return imageUrl; 
}


export {
    useImagePath
 }